var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container"},[_c('div',{staticClass:"row tooltip-wrapper"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-user fa-fw fa-users"}),_vm._v(" "+_vm._s(_vm.$label("organization.organizations", "Organizations"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label(
              'organization.new_organization',
              'New organization'
            ),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label(\n              'organization.new_organization',\n              'New organization'\n            ),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewOrganization' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})])],1)])]),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "organization.organizations_failed_request", "Request failed while loading organizations." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"organizations-table","loading":_vm.loading,"columns":[
      {
        title: 'Name',
        field: 'name',
        id: function (row) { return ("organization-name-" + (row.id)); }
      },
      {
        title: 'Type',
        field: 'type',
        id: function (row) { return ("organization-type-" + (row.id)); }
      },
      {
        title: 'Email',
        field: 'email',
        id: function (row) { return ("organization-email-" + (row.id)); }
      },
      {
        title: 'Website',
        field: 'website',
        id: function (row) { return ("organization-website-" + (row.id)); }
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'OrganizationDetails',
            params: { organization_id: row.id }
          });
        }
      },
      {
        icon: 'envelope-o',
        tooltip: 'Email to this organization',
        onClick: function () {
          _vm.$router.push('#');
        }
      },
      {
        icon: 'mobile',
        bgColor: 'primary',
        tooltip: 'SMS to this organization',
        onClick: function () {
          _vm.$router.push('#');
        }
      },
      {
        type: 'delete',
        id: function (row) { return ("delete-organization-button-" + (row.id)); },
        onClick: function (row) { return _vm.deleteOrganization(row.id); }
      }
    ],"data":_vm.organizations,"meta":_vm.metaData},on:{"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getOrganizations({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewOrganization' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("organization.new_organization", "New organization")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }